export const DASHCARDS_POWER_UP_ID = '6048e897c73d032a983e2a7c';
